<div class="container">
  <h1 style="text-align:center; font-weight: normal;">
    Ciao<br /><b>{{ user?.displayName || user?.email }}</b>, <br />benvenuto.
  </h1>
</div>

<div class="container-intermedio" *ngIf="user && (!user.roles || user.roles.length === 0)">
  <h3>
    Da quanto ci risulta ancora il tuo profilo non è stato ancora abilitato.
  </h3>
  <h3>
    Se sei un Travel Advisor QuoVado, scrivi a
    <a href="mailto:info@quovado.com?subject=Ho creato il mio account su My QuoVado ({{
        user.email
      }})">info@quovado.com</a>
  </h3>
  <h3>
    Altrimenti,
    <a href="https://www.quovado.com/it/inizia-ora?utm_source=mywanderoo">inizia subito e richiedi il tuo itinerario su
      misura!</a>
  </h3>
</div>